import React from "react";
import Loader from "../../Loader";
import { formStyles } from "../formStyles";

export default function ConfirmContactStep(props) {
  const { register, inputs, handleChange, handleSubmit, onConfirmPhoneNumber, isLoading, mask_number } = props;

  return (
    <div className="max-w-xl mx-auto space-y-6 bg-white p-8 border border-gray-100 rounded-2xl shadow-sm">
      <h2 className="text-2xl font-bold text-center text-slate-900">Confirm Contact Details</h2>
      <div className={inputs.current_number === "no" ? "hidden" : "block mt-6"}>
        <label className="block text-center text-slate-700 font-medium mb-4">
          Is this your current phone number? <br/>
          <span className="text-2xl font-bold text-slate-900 mt-2 block tracking-wider">{mask_number(inputs.r_phone)}</span>
        </label>
        <div className="flex justify-center gap-6" onChange={handleChange}>
          <label className="flex items-center cursor-pointer text-lg"><input type="radio" name="current_number" value="yes" required className="mr-2 w-5 h-5 text-blue-600" /> Yes</label>
          <label className="flex items-center cursor-pointer text-lg"><input type="radio" name="current_number" value="no" required className="mr-2 w-5 h-5 text-blue-600" /> No</label>
        </div>
      </div>

      {inputs.current_number === "no" && (
        <div className="mt-4">
          <label className={formStyles.label}>New Phone Number</label>
          <input name="r_phone" type="text" {...register("r_phone", { required: true })} onChange={handleChange} className={formStyles.input} placeholder="080xxxxxxxx" />
        </div>
      )}

      <div className={inputs.valid_email === "no" ? "hidden" : "block mt-8 pt-8 border-t border-gray-100"}>
        <label className="block text-center text-slate-700 font-medium mb-4">
          Is this a valid email address? <br/>
          <span className="text-xl font-bold text-slate-900 mt-2 block">{inputs.r_email}</span>
        </label>
        <div className="flex justify-center gap-6" onChange={handleChange}>
          <label className="flex items-center cursor-pointer text-lg"><input type="radio" name="valid_email" value="yes" required className="mr-2 w-5 h-5 text-blue-600" /> Yes</label>
          <label className="flex items-center cursor-pointer text-lg"><input type="radio" name="valid_email" value="no" required className="mr-2 w-5 h-5 text-blue-600" /> No</label>
        </div>
      </div>

      {inputs.valid_email === "no" && (
        <div className="mt-4">
          <label className={formStyles.label}>New Email Address</label>
          <input name="r_email" type="email" {...register("r_email", { required: true })} onChange={handleChange} className={formStyles.input} placeholder="you@example.com" />
        </div>
      )}

      <button onClick={handleSubmit(onConfirmPhoneNumber)} className={`${formStyles.buttonPrimary} w-full mt-8`}>
        Confirm Contacts {isLoading && <span className="ml-2"><Loader /></span>}
      </button>
    </div>
  );
}